import { render, staticRenderFns } from "./CardDocumentDetails.vue?vue&type=template&id=38d2fa90&"
import script from "./CardDocumentDetails.vue?vue&type=script&lang=js&"
export * from "./CardDocumentDetails.vue?vue&type=script&lang=js&"
import style0 from "./CardDocumentDetails.vue?vue&type=style&index=0&id=38d2fa90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports